<template>
  <div id="app">
    <b-navbar toggleable="lg" type="light" variant="light" class="pb-0 mb-1" v-if="isLoggedIn">
      <b-navbar-brand href="#">
        <img src="@/assets/ed_logo_0.png" style="height:35px;float:left" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- <b-navbar-nav>
          <b-nav-item href="#/dashboard">
            <b-icon icon="house-door" variant="danger"></b-icon>Home
          </b-nav-item>
        </b-navbar-nav>-->
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#/dashboard" class="mr-4">
            <b-icon icon="house-door" variant="primary"></b-icon>Home
          </b-nav-item>
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{username}}</em>
            </template>
            <b-dropdown-item href="#">Profile</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.userFullName;
    }
  },
  methods: {
    logout() {
      this.$session.destroy();
      this.$store.dispatch("logout");
      this.$router.push("/");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 1px;
}
</style>
